import _ from "lodash";
import statuses from "dictionaries/RequestStatuses";

export const cyberOptions = _.pick(statuses, [1, 5, 8, 17, 4]);
export const otaOptions = _.pick(statuses, [1, 5, 8]);
export const bscAndSarOptions = _.pick(statuses, [2, 8]);
export const batteryOptions = _.pick(statuses, [1, 5, 8, 17, 4, 19]);
export const blcOptions = _.pick(statuses, [1, 5, 8, 17, 4, 18]);